export enum ColumnStyleTypeEnum {
	textbox = 0,
	editableDropdown = 1,
	nonEditableDropdown = 2
}
